import { orderBy, uniq, uniqBy } from "lodash";
import { ResultadoAnaliseOS__Item } from "../../../../../../../../../services/AgriculturaPrecisao/bookResumido/GET";
import { removerEspacos } from "../../../../../../../../../utils";
import { Item__MapaFertilidade__Config } from "../../../../../../../../../services/novoConfigBook/get";

type ListaElementos = {
    cod_elemento: number,
    elemento_descricao: string,
    profundidade: string,
    tipo_mapa: 'Fertilidade' | 'Indicadores' | 'Prescrições',
    chave: string
}

export function processarAnalise(lista_analises: ResultadoAnaliseOS__Item[], cod_propriedade: number, config_book?: Item__MapaFertilidade__Config[]): ListaElementos[] {
    
    let apenas_da_propriedade = lista_analises.filter(item=>item.cod_propriedade === cod_propriedade);

    let montar_lista = apenas_da_propriedade.map((item)=> {

        function obterTipoMapa(cod_elemento: number): 'Fertilidade' | 'Indicadores' | 'Prescrições' {
            if ([30, 31, 32, 49, 41, 42, 46, 43, 44, 45].includes(cod_elemento)) {
                return 'Prescrições'
            }
            else if ([33, 34, 28, 38, 50].includes(cod_elemento)) {
                return 'Indicadores'
            }
            else return 'Fertilidade'
        }

        return {
            cod_elemento: item?.cod_elemento,
            elemento_descricao: item?.elemento_descricao,
            profundidade: item?.profundidade,
            tipo_mapa: obterTipoMapa(item?.cod_elemento),
            chave: `${item?.cod_elemento}_${removerEspacos(item?.elemento_descricao)}_${obterTipoMapa(item?.cod_elemento)}`
        }
    });

    let unificar_lista = uniqBy(montar_lista, 'chave');

    if (config_book === undefined) {
        return orderBy(unificar_lista, ['cod_elemento', 'asc']) ?? [];
    }

    let ordenar_lista = unificar_lista.map((item)=> {
        let encontrar_ordem = config_book.find(config=> config?.elemento === item?.cod_elemento);
        return {
            ...item,
            nova_ordem: encontrar_ordem?.secoes?.[0]?.ordem ?? 999
        }
    })
    
    return orderBy(ordenar_lista.filter(i=>i.nova_ordem!==999), 'nova_ordem', ['asc'])
};

export function obterProfundidades(lista_analises: ResultadoAnaliseOS__Item[], cod_propriedade: number):{ profundidade: string, cod_profundidade: number }[] {

    let apenas_da_propriedade = lista_analises.filter(item=>item.cod_propriedade === cod_propriedade);
    
    let unificar_profundidades = uniqBy(apenas_da_propriedade, 'profundidade');

    let montar_lista_profundidades = unificar_profundidades.map(({ profundidade, cod_profundidade })=> {
        return {
            profundidade: profundidade,
            cod_profundidade: cod_profundidade
        }
    });

    return montar_lista_profundidades ?? [];
}

export function filtrarPorTalhao(lista_analises: ResultadoAnaliseOS__Item[], talhoes_selecionados: { descr: string, id: number, key?: number }[]) {
    if (talhoes_selecionados.length === 0) {
        return lista_analises;
    }

    let cods_pedido_talhoes = new Set(talhoes_selecionados.map((i=> i.id)));
    
    let filtrar_por_pedido_talhao = lista_analises.filter(item=> cods_pedido_talhoes.has(item.cod_pedido));

    return filtrar_por_pedido_talhao;
}

export function filtrarApenasPropriedade(lista_analises: ResultadoAnaliseOS__Item[], cod_propriedade: number) {
    let apenas_da_propriedade = lista_analises.filter(item=>item.cod_propriedade === cod_propriedade);
    return apenas_da_propriedade;
};

export function descricaoDefinicao(definicao: string) {
    switch (definicao) {
        case 'Automática':
            return 'Melhor equilíbrio entre nível de detalhamento e tempo de carregamento será aplicado automaticamente pelo sistema.';
        case 'Definição baixa':
            return 'O book é gerado com maior rapidez, porém com menor nível de detalhamento.';
        case 'Definição padrão':
            return 'O nível de detalhamento é gerado conforme a quantidade de dados disponíveis, com um tempo de carregamento moderado.';
        case 'Definição melhorada':
            return 'O book é gerado com o melhor nível de detalhamento possível, porém leva mais tempo para ser gerado.';
        default:
            return '';
    }
};

export function talhoesComPedido(talhoes_selecionados:  { cod_talhao: number, nome_talhao: string, cod_pedido?: number }[], lista_analises: ResultadoAnaliseOS__Item[], cod_propriedade:number) {
    
    let apenas_cod_pedido = uniq(lista_analises.filter(item=>item.cod_propriedade===cod_propriedade).map(item=> item.cod_pedido));

    return (talhoes_selecionados??[])?.filter(item=> apenas_cod_pedido?.includes?.(item?.cod_pedido)) ?? []
}